import React from 'react';

const SvgBs = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BS_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="BS_svg__c">
        <stop stopColor="#FCE569" offset="0%" />
        <stop stopColor="#FADF52" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BS_svg__b" fill="#fff">
        <use xlinkHref="#BS_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BS_svg__a" />
      <path
        fill="#22B7D5"
        mask="url(#BS_svg__b)"
        d="M0 13.333h28V20H0zM0 0h28v6.667H0z"
      />
      <path
        fill="url(#BS_svg__c)"
        mask="url(#BS_svg__b)"
        d="M0 6.667h28v6.667H0z"
      />
      <path fill="#262626" mask="url(#BS_svg__b)" d="M0 0l13.333 10L0 20z" />
    </g>
  </svg>
);

export default SvgBs;
